import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/home/runner/work/acp-mobile-sdkdocs/acp-mobile-sdkdocs/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const Variant = makeShortcode("Variant");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <Variant platform="android" task="add" repeat="5" mdxType="Variant" />
    <h4 {...{
      "id": "java"
    }}>{`Java`}</h4>
    <p>{`Add the `}<a parentName="p" {...{
        "href": "../index.md"
      }}>{`Mobile Core`}</a>{` extension to your project using the app's Gradle file.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-java"
      }}>{`implementation 'com.adobe.marketing.mobile:sdk-core:1.+'
`}</code></pre>
    <p>{`Import the Signal extension in your application's main activity.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-java"
      }}>{`import com.adobe.marketing.mobile.*;
`}</code></pre>
    <Variant platform="ios" task="add" repeat="9" mdxType="Variant" />
    <p>{`​The Signal extension is included in the Mobile Core extension. Add the `}<a parentName="p" {...{
        "href": "../index.md"
      }}>{`Mobile Core`}</a>{` extension to your project using Cocoapods.`}</p>
    <p>{`Add following pods in your `}<inlineCode parentName="p">{`Podfile`}</inlineCode>{`:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-pod"
      }}>{`pod 'ACPCore', '~> 2.0'
`}</code></pre>
    <p>{`Import the Signal libraries:`}</p>
    <h4 {...{
      "id": "objective-c"
    }}>{`Objective-C`}</h4>
    <pre><code parentName="pre" {...{
        "className": "language-objectivec"
      }}>{`#import "ACPCore.h"
#import "ACPSignal.h"
`}</code></pre>
    <h4 {...{
      "id": "swift"
    }}>{`Swift`}</h4>
    <p>{`In Swift, the ACPCore includes ACPSignal:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-swift"
      }}>{`import ACPCore
`}</code></pre>
    <Variant platform="react-native" task="add" repeat="3" mdxType="Variant" />
    <h4 {...{
      "id": "javascript"
    }}>{`JavaScript`}</h4>
    <p>{`Importing the Signal extension:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`import {ACPSignal} from '@adobe/react-native-acpcore';
`}</code></pre>
    <Variant platform="flutter" task="add" repeat="3" mdxType="Variant" />
    <h4 {...{
      "id": "dart"
    }}>{`Dart`}</h4>
    <p>{`Importing the Signal extension:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-dart"
      }}>{`import 'package:flutter_acpcore/flutter_acpsignal.dart';
`}</code></pre>
    <Variant platform="cordova" task="add" repeat="3" mdxType="Variant" />
    <h4 {...{
      "id": "cordova"
    }}>{`Cordova`}</h4>
    <p>{`After creating your Cordova app and adding the Android and iOS platforms, the Signal extension for Cordova can be added with this command:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-text"
      }}>{`cordova plugin add https://github.com/adobe/cordova-acpcore.git
`}</code></pre>
    <Variant platform="unity" task="add" repeat="3" mdxType="Variant" />
    <h4 {...{
      "id": "c"
    }}>{`C#`}</h4>
    <p>{`After importing the `}<a parentName="p" {...{
        "href": "https://github.com/adobe/unity-acpcore/blob/master/bin/ACPCore-0.0.1-Unity.zip"
      }}>{`ACPCore.unitypackage`}</a>{`, the Signal extension for Unity can be added with following code in the MainScript`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-csharp"
      }}>{`using com.adobe.marketing.mobile;
`}</code></pre>
    <Variant platform="xamarin" task="add" repeat="3" mdxType="Variant" />
    <h4 {...{
      "id": "c-1"
    }}>{`C#`}</h4>
    <p>{`After adding the iOS ACPCore NuGet package or the Android ACPSignal NuGet package, the Signal extension can be added by this import statement`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-csharp"
      }}>{`using Com.Adobe.Marketing.Mobile;
`}</code></pre>
    <Variant platform="android" task="register" repeat="4" mdxType="Variant" />
    <h4 {...{
      "id": "java-1"
    }}>{`Java`}</h4>
    <p>{`After calling the `}<inlineCode parentName="p">{`setApplication()`}</inlineCode>{` method in the `}<inlineCode parentName="p">{`onCreate()`}</inlineCode>{` method, register the Signal extension. If the registration was not successful, an `}<inlineCode parentName="p">{`InvalidInitException`}</inlineCode>{` is thrown.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-java"
      }}>{`public class MobileApp extends Application {

    @Override
    public void onCreate() {
        super.onCreate();
        MobileCore.setApplication(this);
        try {
            Signal.registerExtension();
            // register other extensions
            MobileCore.start(new AdobeCallback () {
                @Override
                public void call(Object o) {
                    MobileCore.configureWithAppID("yourAppId");
                }
            });    
        } catch (Exception e) {
            //Log the exception
         }
    }
}
`}</code></pre>
    <p>{`Please note that the Signal extension is automatically included in the Mobile Core extension by Maven. When you manually install the Signal extension, ensure that you add the `}<inlineCode parentName="p">{`signal-1.x.x.aar`}</inlineCode>{` library to your project.`}</p>
    <Variant platform="ios" task="register" repeat="6" mdxType="Variant" />
    <p>{`In your app's`}<inlineCode parentName="p">{`application:didFinishLaunchingWithOptions`}</inlineCode>{`, register the Signal extension with Mobile Core:`}</p>
    <h4 {...{
      "id": "objective-c-1"
    }}>{`Objective-C`}</h4>
    <pre><code parentName="pre" {...{
        "className": "language-objectivec"
      }}>{`- (BOOL)application:(UIApplication *)application didFinishLaunchingWithOptions:(NSDictionary *)launchOptions {
    [ACPCore configureWithAppId:@"yourAppId"];
    [ACPSignal registerExtension];
    [ACPCore start:nil];
    // Override point for customization after application launch.
    return YES;
 }
`}</code></pre>
    <h4 {...{
      "id": "swift-1"
    }}>{`Swift`}</h4>
    <pre><code parentName="pre" {...{
        "className": "language-swift"
      }}>{`func application(_ application: UIApplication, didFinishLaunchingWithOptions launchOptions: [UIApplication.LaunchOptionsKey: Any]?) -> Bool {
     ACPCore.configure(withAppId: "yourAppId")   
     ACPSignal.registerExtension()
     ACPCore.start(nil)
     // Override point for customization after application launch.
     return true;
}
`}</code></pre>
    <p>{`Please note that the Signal extension is automatically included in the Mobile Core pod. When you manually install the Signal extension, ensure that you add the `}<inlineCode parentName="p">{`libACPSignal_iOS.a`}</inlineCode>{` library to your project.`}</p>
    <Variant platform="react-native" task="register" repeat="2" mdxType="Variant" />
    <h4 {...{
      "id": "javascript-1"
    }}>{`JavaScript`}</h4>
    <p>{`When using React Native, registering Signal with Mobile Core should be done in native code which is shown under the Android and iOS tabs.`}</p>
    <Variant platform="flutter" task="register" repeat="2" mdxType="Variant" />
    <h4 {...{
      "id": "dart-1"
    }}>{`Dart`}</h4>
    <p>{`When using Flutter, registering Signal with Mobile Core should be done in native code which is shown under the Android and iOS tabs.`}</p>
    <Variant platform="cordova" task="register" repeat="2" mdxType="Variant" />
    <h4 {...{
      "id": "cordova-1"
    }}>{`Cordova`}</h4>
    <p>{`When using Cordova, registering Signal with Mobile Core must be done in native code which is shown under the Android and iOS tabs.`}</p>
    <Variant platform="unity" task="register" repeat="3" mdxType="Variant" />
    <h4 {...{
      "id": "c-2"
    }}>{`C#`}</h4>
    <p>{`Register the extension in the `}<inlineCode parentName="p">{`start()`}</inlineCode>{` function:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-csharp"
      }}>{`void Start()
{   
  ACPSignal.RegisterExtension();
}
`}</code></pre>
    <Variant platform="xamarin" task="register" repeat="7" mdxType="Variant" />
    <h4 {...{
      "id": "c-3"
    }}>{`C#`}</h4>
    <p><strong parentName="p">{`iOS`}</strong></p>
    <p>{`Register the Signal extension with the Mobile Core by adding the following to your app's `}<inlineCode parentName="p">{`FinishedLaunching:`}</inlineCode>{` delegate method:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-csharp"
      }}>{`public override bool FinishedLaunching(UIApplication app, NSDictionary options)
{
  ACPSignal.RegisterExtension();
  // start Mobile Core
  ACPCore.Start(startCallback);

  return base.FinishedLaunching(app, options);
}

private void startCallback()
{
  // set app id from the Data Collection UI
  ACPCore.ConfigureWithAppID("yourAppId");
}
`}</code></pre>
    <p><strong parentName="p">{`Android`}</strong></p>
    <p>{`Register the Signal extension with the Mobile Core by adding the following to your app's `}<inlineCode parentName="p">{`OnCreate:`}</inlineCode>{` method:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-csharp"
      }}>{`protected override void OnCreate(Bundle savedInstanceState)
{
  base.OnCreate(savedInstanceState);
    LoadApplication(new App());
  ACPCore.Application = this.Application;
  ACPSignal.RegisterExtension();
  // start Mobile Core
  ACPCore.Start(new CoreStartCompletionCallback());
}

class CoreStartCompletionCallback : Java.Lang.Object, IAdobeCallback
{
  public void Call(Java.Lang.Object callback)
  {
  // set app id from the Data Collection UI
    ACPCore.ConfigureWithAppID("yourAppId");
  }
}
`}</code></pre>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      